import moment from "moment";

// Interfaces
import { ICommissionCycle, IPayPeriod } from "@/Common/api/types/CommissionCycle";

// Helpers
import { or } from "@/Common/helpers/sonar";
import { getDateByTimeZone } from "@dealerwave/dw-layer-date-converter";

interface TGetDisabledMessageArgs {
	commissionCycle?: ICommissionCycle;
	payPeriods: IPayPeriod[];
	payPeriod?: IPayPeriod;
	timezone: string;
}

export const getDisabledMessage = (args: TGetDisabledMessageArgs) => {
	const { commissionCycle, payPeriods, payPeriod, timezone } = args;

	if (or(!commissionCycle, !payPeriod)) {
		return "There is no Commission Cycle or Pay Period to check.";
	}

	// Commission Cycle already finalized
	if (commissionCycle?.status === "FINALIZED") {
		return "Commission Cycle is FINALIZED.";
	}

	// Pay Period already completed.
	if (payPeriod?.status === "COMPLETED") {
		return "Pay Period is in COMPLETED status.";
	}

	// Check if any position is set as commission/commission draw
	if (payPeriod?.positionStatus.every((positionStatus) => positionStatus.status === "UNREVIEWABLE")) {
		return "No Managed Position is set as Commission Draw.";
	}

	// Pay Period already in review
	if (!payPeriod?.positionStatus.some((positionStatus) => positionStatus.status === "PENDING")) {
		return "All positions are already in review.";
	}

	// Pay Period has not ended yet
	const currentDate = getDateByTimeZone(timezone, moment(), { dateType: "Moment" });
	if (currentDate?.isBefore(moment(payPeriod.endDate))) {
		return "Pay Period has not ended yet.";
	}

	// Previous Pay Period of the Commission Cycle is inReview or with state "INITIAL", that one should be reviewed first
	if (payPeriods.some((period) => moment(period.endDate).isBefore(payPeriod.endDate) && period.status !== "COMPLETED")) {
		return "A previous Pay Period in the Commission Cycle is not COMPLETED.";
	}

	return null;
};
